import { render, staticRenderFns } from "./UserFormProfile.vue?vue&type=template&id=77145e98&scoped=true"
import script from "./UserFormProfile.vue?vue&type=script&lang=js"
export * from "./UserFormProfile.vue?vue&type=script&lang=js"
import style0 from "./UserFormProfile.vue?vue&type=style&index=0&id=77145e98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77145e98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77145e98')) {
      api.createRecord('77145e98', component.options)
    } else {
      api.reload('77145e98', component.options)
    }
    module.hot.accept("./UserFormProfile.vue?vue&type=template&id=77145e98&scoped=true", function () {
      api.rerender('77145e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/Form/UserFormProfile.vue"
export default component.exports